import type { SocnaColorEnum } from '@e-socna/data-layer';

import {
  DEFAULT_THEME_COLOR,
  SOCNA_THEME_COLORS,
} from '../constants/socna-theme-colors.constant';
import type { ThemeColor } from '../constants/socna-theme-colors.constant';

export const themeColorOf = (
  socnaColor: SocnaColorEnum | null | undefined,
): ThemeColor =>
  socnaColor ? SOCNA_THEME_COLORS[socnaColor] : DEFAULT_THEME_COLOR;
